export const BE_CO2_FEE = 31.34
